(function () {
  const product = document.querySelector('.product--large');
  if (!product) return;

  const accordions = [...product.querySelectorAll('.product__accordion')];
  if (accordions.length === 0) return;

  const firstAccordion = accordions[0];
  const parent = firstAccordion.parentNode;

  const wrapper = document.createElement('div');
  wrapper.className = 'product-tabs';

  const labelsBar = document.createElement('div');
  labelsBar.className = 'product-tabs__labels';
  labelsBar.setAttribute('role', 'tablist');

  const panelsArea = document.createElement('div');
  panelsArea.className = 'product-tabs__panels';

  accordions.forEach(function (accordion, i) {
    const heading = accordion.querySelector('.accordion__title')?.textContent.trim() ?? '';
    const content = accordion.querySelector('.accordion__content')?.innerHTML ?? '';
    const panelId = 'product-tab-panel-' + i;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'product-tabs__label' + (i === 0 ? ' active' : '');
    btn.setAttribute('role', 'tab');
    btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
    btn.setAttribute('aria-controls', panelId);
    btn.textContent = heading;
    btn.addEventListener('click', function () { activate(wrapper, btn, panelId); });
    labelsBar.appendChild(btn);

    const panel = document.createElement('div');
    panel.className = 'product-tabs__panel rte' + (i === 0 ? ' active' : '');
    panel.setAttribute('role', 'tabpanel');
    panel.id = panelId;
    panel.innerHTML = content;
    panelsArea.appendChild(panel);
  });

  wrapper.appendChild(labelsBar);
  wrapper.appendChild(panelsArea);
  parent.insertBefore(wrapper, firstAccordion);
  accordions.forEach(function (a) { a.remove(); });

  function activate(wrapper, activeBtn, activePanelId) {
    wrapper.querySelectorAll('.product-tabs__label').forEach(function (b) {
      b.classList.remove('active');
      b.setAttribute('aria-selected', 'false');
    });
    wrapper.querySelectorAll('.product-tabs__panel').forEach(function (p) {
      p.classList.remove('active');
    });
    activeBtn.classList.add('active');
    activeBtn.setAttribute('aria-selected', 'true');
    wrapper.querySelector('#' + activePanelId).classList.add('active');
  }
})();
